import { Controller } from "@hotwired/stimulus"
import { saveFile } from "../helpers"

export default class extends Controller {
  static targets = ["downloadAllButton", "readyButton", "code"]
  static classes = ["lightButton"]
  static values = { replaceUrl: String }

  savedCodes = false

  // Kody renderuje odpowiedź na POST (nie redirect), więc adres w pasku i w historii to akcja POST-a — podmieniamy go na
  // profil, żeby „wstecz"/odświeżenie nie odtwarzały POST-a GET-em. history.state zostaje (Turbo trzyma tam swój stan).
  connect() {
    if (this.hasReplaceUrlValue && this.replaceUrlValue && window.location.pathname !== this.replaceUrlValue) {
      history.replaceState(history.state, "", this.replaceUrlValue)
    }
  }

  copiedCodes(event) {
    // clipboard:copied bąbelkuje też z przycisków per-kod (własne kontrolery clipboard na <button>);
    // skopiowanie JEDNEGO kodu nie oznacza kompletu jako zapisanego. Kopiowanie wszystkich idzie
    // z kontrolera clipboard na tym samym elemencie co ten kontroler; wywołanie bez zdarzenia = download.
    if (event && event.target !== this.element) return

    this.markSaved()
    if (this.hasReadyButtonTarget) this.readyButtonTarget.classList.remove("hidden")

    if (this.hasDownloadAllButtonTarget) {
      this.downloadAllButtonTarget.className = ""
      this.downloadAllButtonTarget.classList.add(...this.lightButtonClasses)
    }
  }

  markSaved() {
    this.savedCodes = true
  }

  // Odświeżenie/zamknięcie karty z niezapisanymi kodami — natywne ostrzeżenie przeglądarki
  // (kody pokazujemy raz; Turbo-nawigację łapie warnUnsaved, pełny unload tylko to zdarzenie).
  warnUnsavedUnload(event) {
    if (this.savedCodes) return

    event.preventDefault()
    event.returnValue = ""
  }

  downloadCodes(event) {
    const codes = this.codeTargets.map(code => code.textContent.trim()).join("\n")
    const blob = new Blob([codes], { type: "text/plain" })
    saveFile(`${event.params.fileName}`, null, blob)
    this.copiedCodes()
  }

  // Schowanie modala (tło, Esc) z niezapisanymi kodami: bez potwierdzenia modal zostaje; po potwierdzeniu chowa się.
  warnUnsavedHide(event) {
    if (!event.target.contains(this.element) || this.savedCodes) return

    const confirmed = confirm(event.params.liveWarning ? event.params.liveWarning : "Masz niezapisany kod. Na pewno chcesz opuścić stronę?")
    if (confirmed) {
      this.savedCodes = true
    } else {
      event.preventDefault()
    }
  }

  warnUnsaved(event) {
    if (!this.savedCodes) {
      event.preventDefault()
      event.stopImmediatePropagation()
      if (confirm(event.params.liveWarning ? event.params.liveWarning : "Masz niezapisany kod. Na pewno chcesz opuścić stronę?")) {
        this.savedCodes = true
        Turbo.visit(event.detail.url)
      }
    }
  }
}
